import {
  CONVERSATION_LIST_SEARCH_MAX,
  type ConversationListContactStateName,
  type ConversationListSortName,
  type ConversationListStatusName,
  type ConversationListViewName,
  type PlatformTypeName,
} from "@multi-chat/shared";

/** Client query for GET /organizations/:id/conversations. Matches the P3-API contract. */
export interface ConversationListClientQuery {
  cursor?: string;
  limit?: number;
  search?: string;
  platform?: PlatformTypeName;
  unread?: boolean;
  contactState?: ConversationListContactStateName;
  sort?: ConversationListSortName;
  view?: ConversationListViewName;
  status?: ConversationListStatusName;
}

export function normalizeConversationSearch(raw: string | undefined): string | undefined {
  if (raw == null) {
    return undefined;
  }
  const trimmed = raw.trim();
  if (trimmed.length === 0) {
    return undefined;
  }
  return trimmed.length > CONVERSATION_LIST_SEARCH_MAX
    ? trimmed.slice(0, CONVERSATION_LIST_SEARCH_MAX)
    : trimmed;
}

export function buildConversationListSearchParams(
  query: ConversationListClientQuery,
): URLSearchParams {
  const params = new URLSearchParams();
  if (query.cursor) {
    params.set("cursor", query.cursor);
  }
  if (query.limit != null) {
    params.set("limit", String(query.limit));
  }
  const search = normalizeConversationSearch(query.search);
  if (search) {
    params.set("search", search);
  }
  if (query.platform) {
    params.set("platform", query.platform);
  }
  if (query.unread === true) {
    params.set("unread", "true");
  }
  if (query.contactState) {
    params.set("contactState", query.contactState);
  }
  if (query.sort) {
    params.set("sort", query.sort);
  }
  if (query.view && query.view !== "ALL") {
    params.set("view", query.view);
  }
  if (query.status && query.status !== "ALL") {
    params.set("status", query.status);
  }
  return params;
}

export function conversationListPath(
  organizationId: number,
  query: ConversationListClientQuery = {},
): string {
  const encoded = buildConversationListSearchParams(query).toString();
  const path = `/organizations/${organizationId}/conversations`;
  return encoded.length > 0 ? `${path}?${encoded}` : path;
}
